import React from 'react'
import css from './patientCard.css'
import { choosePhoneNumberFormatter } from '../../../services/formatters'

const PatientPhones = ({ patient: { reminders_phone }, countryCode }) => {
  const formattedNumber = choosePhoneNumberFormatter(countryCode)(reminders_phone)
  return (
    <div className={css.contactItem}>
      <span className={css.label}>Reminders Phone</span>
      <span className={css.value}>{formattedNumber}</span>
    </div>
  )
}

export default PatientPhones



// WEBPACK FOOTER //
// ./src/components/PatientPage/PatientCard/Phones.js